<div class="platform-terms-reacceptance">
  <div
    class="nudge-icon-frame tw-mx-auto tw-mb-4 tw-w-fit tw-rounded-full tw-bg-primary-light tw-p-4"
    aria-hidden="true"
  >
    <div class="pitchin-icon pitchin-icon-shield-red tw-h-8 tw-w-8"></div>
  </div>

  <h2 id="platform-terms-reacceptance-title" class="nudge-title">
    {{ 'login.platformTermsReacceptance.title' | translate }}
  </h2>
  <p class="nudge-intro">{{ 'login.platformTermsReacceptance.intro' | translate }}</p>

  <!-- Points at the platform-wide Website Terms of Use, where the consolidated P2P /
       wallet sections live (pending Q5 — the consolidated /terms-conditions page). -->
  <p class="nudge-review">
    <a href="/website-terms-conditions" target="_blank" rel="noopener">
      {{ 'login.platformTermsReacceptance.reviewLink' | translate }}
    </a>
    <span *ngIf="version" class="nudge-version">({{ version }})</span>
  </p>

  <ng-container *ngIf="versionKnown; else versionUnavailable">
    <p *ngIf="versionChanged" class="nudge-version-changed" role="status">
      {{ 'login.platformTermsReacceptance.versionChanged' | translate }}
    </p>

    <label class="nudge-agree">
      <input type="checkbox" [(ngModel)]="agreed" [disabled]="submitting || loadingVersion" />
      <span>{{ 'login.platformTermsReacceptance.agree' | translate }}</span>
    </label>

    <div class="nudge-actions">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!agreed || submitting || loadingVersion"
        (click)="accept()"
      >
        <span
          *ngIf="submitting"
          class="spinner-border spinner-border-sm tw-mr-2"
          role="status"
          aria-hidden="true"
        ></span>
        {{ 'login.platformTermsReacceptance.accept' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- The version in force could not be determined (the status check failed, so the gate was
       queued fail-closed). Nothing is offered for acceptance until it is known. -->
  <ng-template #versionUnavailable>
    <p class="nudge-version-unavailable" role="alert">
      {{ 'login.platformTermsReacceptance.versionUnavailable' | translate }}
    </p>
    <div class="nudge-actions">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="loadingVersion"
        (click)="loadVersion()"
      >
        <span
          *ngIf="loadingVersion"
          class="spinner-border spinner-border-sm tw-mr-2"
          role="status"
          aria-hidden="true"
        ></span>
        {{ 'login.platformTermsReacceptance.retry' | translate }}
      </button>
    </div>
  </ng-template>
</div>
